import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const steps = [
  {
    number: "01",
    title: "Requirements",
    description: "Understanding application scope, features, and acceptance criteria.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "02",
    title: "Test Planning",
    description: "Defining strategy, scope, resources, and test deliverables.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 9h8M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "03",
    title: "Test Design",
    description: "Creating test cases, scenarios, and data for full coverage.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 10h16M10 4v16" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    number: "04",
    title: "Execution",
    description: "Running manual and automated tests across environments.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M8 6L4 12L8 18M16 6l4 6-4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "05",
    title: "Reporting",
    description: "Documenting defects, severity, and detailed test results.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "06",
    title: "Regression & Release",
    description: "Re-testing fixes and signing off for production deployment.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const StestProcess: React.FC = () => {
  return (
    <section className="wdev-process" aria-labelledby="stest-process-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="stest-process-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Our Software Testing Process
          </h2>
        </AnimatedSection>

        <div className="wdev-process__timeline">
          <div className="wdev-process__line" aria-hidden="true" />
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              className="wdev-process__step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="wdev-process__badge">{step.number}</div>
              <div className="wdev-process__card">
                <div className="wdev-process__icon">{step.icon}</div>
                <h3 className="wdev-process__title">{step.title}</h3>
                <p className="wdev-process__desc">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StestProcess;
